import { YouTubeVideoId } from '@customer/config/videos';
import PaywallPage from '@customer/templates/paywall-page/PaywallPage';
import { useTranslation } from 'react-i18next';

export function HomePaywall() {
  const { t } = useTranslation();

  return (
    <PaywallPage
      title={t('HomePaywallTitle')}
      subtitle={t('HomePaywallSubtitle')}
      description={t('HomePaywallDescription')}
      videoProps={{
        videoId: YouTubeVideoId.ImprovedReporting,
        title: t('HomePaywallVideoTitle'),
      }}
    />
  );
}

export default HomePaywall;
